import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const Title = styled(Typography)`
  margin: 0;
  color: #0a1f44;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
`;

export const Description = styled(Typography)`
  margin: 16px 0 0;
  color: #0a1f44;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
`;

export const Meta = styled(Typography)`
  margin: 16px 0 0;
  color: #0a1f44;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
`;
